import { Reveal } from "@/components/Reveal";
import { Star, Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    initials: "MG",
    name: "María González",
    city: "Salou",
    quote:
      "Me instalaron un split 1x1 en el salón en una sola mañana. Puntuales, limpios y me explicaron todo el funcionamiento antes de irse. La garantía por escrito me dio mucha tranquilidad.",
    testid: "testimonial-0",
  },
  {
    initials: "JP",
    name: "Jordi Puig",
    city: "Tarragona",
    quote:
      "Teníamos dudas entre conductos y multi-split para el piso entero. Hicieron el estudio, nos dieron presupuesto claro sin sorpresas y la instalación quedó perfecta. Repetiría sin dudar.",
    testid: "testimonial-1",
  },
  {
    initials: "LR",
    name: "Laura Rodríguez",
    city: "Cambrils",
    quote:
      "Para mi tienda necesitaban una cassette y coordinarse fuera del horario comercial. Cero molestias para los clientes y el local a la temperatura perfecta desde el primer día.",
    testid: "testimonial-2",
  },
];

export const Testimonials = () => (
  <section id="opiniones" data-testid="testimonials-section" className="bg-white py-16 sm:py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
      <Reveal className="max-w-2xl">
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-ocean-600">
          Opiniones de Clientes
        </p>
        <h2 className="mt-4 font-display text-2xl font-bold tracking-tight text-navy sm:text-3xl lg:text-4xl text-balance">
          Lo que dicen quienes ya confían en nosotros
        </h2>
        <p className="mt-5 text-base leading-relaxed text-slate-600">
          Cada instalación terminada es un cliente que nos recomienda. Estas son algunas
          de las experiencias de hogares y negocios de Tarragona y Barcelona.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-6 md:grid-cols-3">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.12}>
            <figure
              data-testid={t.testid}
              className="flex h-full flex-col rounded-3xl border border-slate-200 bg-ocean-50/40 p-6 transition-all duration-300 hover:-translate-y-1.5 hover:border-ocean-600/30 hover:shadow-xl hover:shadow-ocean-600/5 sm:p-8"
            >
              <div className="flex items-center justify-between">
                <div className="flex gap-1" aria-label="Valoración de 5 sobre 5">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} className="h-4 w-4 fill-ember text-ember" />
                  ))}
                </div>
                <Quote className="h-6 w-6 text-ocean-600/30" />
              </div>
              <blockquote className="mt-5 flex-1 text-sm leading-relaxed text-slate-600">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-slate-200 pt-5">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-navy font-display text-xs font-bold text-white">
                  {t.initials}
                </span>
                <div>
                  <p className="font-display text-sm font-bold text-navy">{t.name}</p>
                  <p className="text-xs text-slate-500">{t.city}</p>
                </div>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
